import { useNavigate } from "react-router-dom";
const network = `${process.env.PUBLIC_URL}/photos/network.png`;
const growth = `${process.env.PUBLIC_URL}/photos/growth.png`;
const heart = `${process.env.PUBLIC_URL}/photos/heart.png`;


const SignupMarketing = () => {
    const navigate = useNavigate();

    const handleLogo = () => {
        navigate("/vendors");
    };

    return (
        <div className='bg-gradient-to-b from-[#2c021e] to-[#94206a] h-screen flex flex-col justify-center items-center relative'>
            <div className="fixed top-0 left-0 right-0 z-40">
                <div className="w-full h-[60px] flex flex-row justify-between items-center px-basePx xs:px-xsPx 1.5xl:py-[18px] 1.5xl:px-[104px]">
                    <button className='cursor-pointer' onClick={handleLogo}>
                        <img src={'https://charmhealth-marketplace-assets.s3.amazonaws.com/Homepage/charmhealthhub_logo_wht_ylw.png'} alt="Logo" className="w-[248px] min-w-[248px] xl:w-[280px]" />
                    </button>
                </div>
            </div>

            <div className="mt-16 flex flex-col">
                <div className="w-fit mx-auto">
                    <h3 className="text-white text-[36px] font-bold text-center font-all-round-gothic-bold">Register as a Vendor</h3>
                </div>

                <div className="w-full flex flex-col py-12 px-20 ">
                    <div className="flex flex-col justify-between gap-[60px]">
                        <div className="w-fit mx-auto flex flex-col items-center gap-[20px]">
                            <div className="h-[50px] w-[50px]">
                                <img src={heart} alt="Network" className="w-full h-full object-contain" />
                            </div>
                            <h3 className="text-white text-[20px] text-center font-proximanova">Put Your Solution At The Heart of Healthcare</h3>

                        </div>

                        <div className="w-fit mx-auto flex flex-col items-center gap-[20px]">
                            <div className="h-[50px] w-[50px]">
                                <img src={network} alt="Network" className="w-full h-full object-contain" />
                            </div>
                            <h3 className="text-white text-[20px] text-center font-proximanova">Streamline your sales and marketing efforts</h3>

                        </div>

                        <div className="w-fit mx-auto flex flex-col items-center gap-[20px]">
                            <div className="h-[50px] w-[50px]">
                                <img src={growth} alt="Network" className="w-full h-full object-contain" />
                            </div>
                            <h3 className="text-white text-[20px] text-center font-proximanova">Unlock your potential for growth</h3>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default SignupMarketing;